import { render } from "./FaturaHistorico.vue?vue&type=template&id=1a5cde22&scoped=true"
import script from "./FaturaHistorico.vue?vue&type=script&lang=js"
export * from "./FaturaHistorico.vue?vue&type=script&lang=js"

import "./FaturaHistorico.vue?vue&type=style&index=0&id=1a5cde22&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5cde22"]])

export default __exports__